import React from 'react'
import { Link } from "react-router-dom";
import PropTypes from "prop-types"
import "./SGTitle-style.css"

const ArrowIcon = props => {
    let img;

    switch(props.direction){
        case "left":
            img = <img className="sg-icon mr-3" src={require("../../assets/images/left-arrow.png")} alt="prev"/>
            break;
        default:
            img = <img className="sg-icon ml-3" src={require("../../assets/images/right-arrow.png")} alt="next"/>;
            break;
    }

    return (
        <Link to={props.to} className="arrow-style">
            {img}
        </Link>
    )
}

export default ArrowIcon

ArrowIcon.propTypes = {
    direction: PropTypes.oneOf(["right", "left"]),
    to: PropTypes.string.isRequired,
}